import { useDialogs } from '@ui/core'

export default useDialogs
